import { render, staticRenderFns } from "./AdmittedEditCard.vue?vue&type=template&id=c818a990&scoped=true&"
import script from "./AdmittedEditCard.vue?vue&type=script&lang=js&"
export * from "./AdmittedEditCard.vue?vue&type=script&lang=js&"
import style0 from "./AdmittedEditCard.vue?vue&type=style&index=0&id=c818a990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c818a990",
  null
  
)

export default component.exports